var _dec, _dec2, _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { WithholdingConfigService } from '@square/dashboard-protos/models/squareup/banking/withholding_config_service';
import Service, { inject as service } from '@ember/service';
import { computed, notifyPropertyChange } from '@ember/object';
import rpc, { apiHostUrl } from '@banking/api/utils/rpc';
let BankingWithholdingConfigApi = (_dec = computed('withholdingConfigsMap'), _dec2 = computed('capitalEngineContext.headers'), _class = class BankingWithholdingConfigApi extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "capitalEngineContext", _descriptor, this);
    // Map of bankc accountIds with the associated most recent withholding config
    // { accountId: withholdingConfig }
    _defineProperty(this, "withholdingConfigsMap", new Map());
  }
  get withholdingConfigs() {
    return [...this.withholdingConfigsMap.values()];
  }
  get client() {
    return WithholdingConfigService.create(rpc(apiHostUrl, new Map(Object.entries(this.capitalEngineContext.headers))));
  }
  async create(withholdingConfigToCreate) {
    const {
      withholdingConfig
    } = await this.client.createWithholdingConfig({
      withholdingConfig: withholdingConfigToCreate
    });
    if (!withholdingConfig) {
      throw new Error('failed to create withholding config');
    }
    this.withholdingConfigsMap.set(withholdingConfig.accountId, withholdingConfig);
    notifyPropertyChange(this, 'withholdingConfigsMap');
    return withholdingConfig;
  }
  async fetchWithholdingConfigs(accountIds) {
    if (accountIds.length === 0) {
      return;
    }
    const {
      withholdingConfigs
    } = await this.client.listWithholdingConfigs({
      accountIds,
      includeMostRecentOnly: true
    });
    withholdingConfigs.forEach(withholdingConfig => {
      this.withholdingConfigsMap.set(withholdingConfig.accountId, withholdingConfig);
    });
    notifyPropertyChange(this, 'withholdingConfigsMap');
  }
  async list(accountIds = []) {
    // Only fetch for accounts that aren't cached
    const accountsToFetch = accountIds.filter(accountId => {
      return !this.withholdingConfigsMap.has(accountId);
    });
    await this.fetchWithholdingConfigs(accountsToFetch);
    const withholdingConfigs = [];
    accountIds.forEach(accountId => {
      const withholdingConfig = this.withholdingConfigsMap.get(accountId);
      if (withholdingConfig) {
        withholdingConfigs.push(withholdingConfig);
      }
    });
    return withholdingConfigs;
  }
  async update(withholdingConfigToUpdate) {
    const {
      withholdingConfig
    } = await this.client.updateWithholdingConfig({
      withholdingConfig: withholdingConfigToUpdate
    });
    if (!withholdingConfig) {
      // FIXME: we need to revert whatever changes were made
      throw new Error('failed to update withholding config');
    }
    this.withholdingConfigsMap.set(withholdingConfig.accountId, withholdingConfig);
    notifyPropertyChange(this, 'withholdingConfigsMap');
    return withholdingConfig;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "capitalEngineContext", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "withholdingConfigs", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "withholdingConfigs"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "client", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "client"), _class.prototype), _class);
export { BankingWithholdingConfigApi as default };